// Category / sub-category metadata for the "Information & Reports" section.
// Must stay in sync with the website's reportsConfig.js (same category codes
// and sub_category slugs the backend stores).

export const REPORT_CATEGORIES = [
  {
    category: "POLICIES_MANUALS",
    title: "Policies, Manuals, Regulations and Guidelines",
    subcategories: [
      { slug: "policies", label: "Policies" },
      { slug: "manuals", label: "Manuals" },
      { slug: "regulations", label: "Regulations" },
      { slug: "guidelines", label: "Guidelines" },
    ],
  },
  {
    category: "ADMINISTRATIVE_REPORTS",
    title: "Administrative Reports",
    subcategories: [
      { slug: "annual-nss-unit-reports", label: "Annual NSS Unit Reports" },
      { slug: "clac-minutes-mom", label: "CLAC Minutes and Other MoM" },
      { slug: "action-taken-reports", label: "Action Taken Reports" },
      { slug: "enrolment-reports", label: "Enrolment Reports" },
      { slug: "service-completion-reports", label: "Service Completion Reports" },
      { slug: "financial-reports", label: "Financial Reports" },
      { slug: "nss-best-practices-report", label: "NSS Best Practices Report" },
      { slug: "social-impact-assessment-reports", label: "Social Impact Assessment Reports" },
      { slug: "industry-collaboration-reports", label: "Industry Collaboration Reports" },
      { slug: "mous", label: "MoUs" },
      { slug: "adopted-village-reports", label: "Adopted Village Reports" },
      { slug: "achievement-and-awards-reports", label: "Achievement and Awards Reports" },
      { slug: "press-publicity-reports", label: "Press & Publicity Reports" },
      { slug: "other-reports", label: "Other Reports" },
    ],
  },
  {
    category: "ACTIVITY_EVENT_REPORTS",
    title: "Activity & Event Reports",
    subcategories: [
      { slug: "nss-annual-calendar", label: "NSS Annual Calendar" },
      { slug: "elp-cbp-reports", label: "ELP and CBP Reports" },
      { slug: "health-wellness-activities", label: "Health and Wellness Activities" },
      { slug: "environmental-cleanliness-initiatives", label: "Environmental & Cleanliness Initiatives" },
      { slug: "awareness-social-campaigns", label: "Awareness & Social Campaigns" },
      { slug: "education-training-programmes", label: "Education & Training Programmes" },
      { slug: "community-outreach-services", label: "Community Outreach & Services" },
    ],
  },
  {
    category: "CAMP_REPORTS",
    title: "Camp Reports",
    subcategories: [
      { slug: "annual-camp-reports", label: "Annual Camp Reports" },
      { slug: "special-camp-reports", label: "Special Camp Reports" },
      { slug: "national-level-camp-reports", label: "National-Level Camp Reports" },
      { slug: "regional-state-level-camp-reports", label: "Regional & State-Level Camp Reports" },
      { slug: "thematic-camp-reports", label: "Thematic Camp Reports" },
    ],
  },
];

// Fixed upload "type" — uploaded report files land in uploads/REPORTS_FILE/.
export const REPORT_UPLOAD_TYPE = "REPORTS_FILE";

export function getSubcategories(category) {
  const found = REPORT_CATEGORIES.find((c) => c.category === category);
  return found ? found.subcategories : [];
}

export function subLabel(category, slug) {
  const subs = getSubcategories(category);
  const f = subs.find((s) => s.slug === slug);
  return f ? f.label : slug;
}
